import toggleMenu from './partials/toggle-menu.js'
import scrollDown from './partials/scroll-down.js'
import sparklesAnim from './partials/sparkles-anim.js'

toggleMenu()
scrollDown()

sparklesAnim('#menuAnim')

if (document.querySelector('#errorAnim')) {
  sparklesAnim('#errorAnim')
}
